<template>
  <div class="">
    <NuxtLoadingIndicator color="red" />
    <div class="shadow">
      <UContainer class="py-4">
        <div class="flex">
          <div class="flex-1">
            <NuxtLink to="/" class="mr-6"><img src="~/assets/icons/emblem-fc.svg" alt="Frederique Constant"
                class="h-6 inline-block mr-2" /><img src="~/assets/icons/emblem-al.svg" alt="Alpina"
                class="h-4 inline-block mr-4" /><span class="uppercase">Retailer Locator</span></NuxtLink>
          </div>
          <div class="self-end flex items-center">

            <div v-if="user.role !== 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87' && user.role !=='4195f36a-5cdd-40c8-81aa-d4d8aec654fa'"
              class="relative inline-block mr-2" ref="marketDropdownRef">
              <UButton color="neutral" variant="outline" class="uppercase"
                :class="{ 'bg-gray-200 font-bold': isActive('/distributors') }" @click="toggleMarketMenu">
                My Market
                <svg class="ml-2 w-4 h-4 transition-transform" :class="{ 'rotate-180': isMarketMenuOpen }" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </UButton>

              <!-- Sous-menu : un lien par distributeur auquel le user est rattache -->
              <div v-show="isMarketMenuOpen"
                class="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div class="py-1 max-h-96 overflow-y-auto">
                  <NuxtLink v-for="access in marketAccesses" :key="access.id"
                    :to="{ name: 'distributors-distributor', params: { distributor: access.distributor.id } }"
                    class="flex items-center justify-between gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    @click="isMarketMenuOpen = false">
                    <span class="truncate">{{ access.distributor.title }}</span>
                    <span
                      class="shrink-0 text-xs font-semibold text-red-600 bg-red-50 border border-red-100 rounded px-1.5 py-0.5">
                      {{ access.distributor.marketCode }}
                    </span>
                  </NuxtLink>

                  <div v-if="!usersStore.user" class="px-4 py-3 text-sm text-gray-400">
                    Loading your markets…
                  </div>
                  <div v-else-if="!marketAccesses.length" class="px-4 py-3 text-sm text-gray-500">
                    No market linked to your account.
                  </div>
                </div>
              </div>
            </div>


            <!-- Dropdown personnalisé -->
            <div class="relative inline-block mr-2" ref="dropdownRef">
              <UButton color="neutral" variant="outline" class="uppercase" @click="toggleDropdown">
                Ewarranty Access
                <svg class="ml-2 w-4 h-4" :class="{ 'rotate-180': isDropdownOpen }" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </UButton>

              <!-- Menu dropdown -->
              <div v-show="isDropdownOpen"
                class="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div class="py-1">
                  <button @click="openAlpina"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    Alpina
                  </button>
                  <button @click="openFC"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    Frederique Constant
                  </button>
                </div>
              </div>
            </div>

            <!-- Menu utilisateur : identite et actions de compte -->
            <div v-if="user" class="relative inline-block" ref="userDropdownRef">
              <UButton color="neutral" variant="outline" @click="toggleUserMenu">
                <svg class="w-4 h-4 mr-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                <span class="text-sm font-medium">Welcome {{ userFullName }}</span>
                <svg class="ml-2 w-4 h-4 transition-transform" :class="{ 'rotate-180': isUserMenuOpen }" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </UButton>

              <div v-show="isUserMenuOpen"
                class="absolute right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 w-80">
                <!-- Identite complete ici plutot que dans le bouton : deux lignes
                     de texte le rendraient plus haut que ses voisins de la barre.
                     Les futures entrees de compte viendront juste en dessous. -->
                <div class="px-4 py-3 border-b border-gray-100">
                  <p class="text-sm font-medium text-gray-900">{{ userFullName }}</p>
                  <p class="text-xs text-gray-500 break-all text-[10px]"><svg class="w-4 h-4 mr-3 shrink-0 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
</svg>{{ user.email }}</p>
                </div>

                <div class="py-1">

                  <NuxtLink v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87' || user.role === '4195f36a-5cdd-40c8-81aa-d4d8aec654fa'" to="/distributors" @click="isUserMenuOpen = false"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    :class="{ 'bg-gray-100 font-semibold text-gray-900': isActive('/distributors') }">
                    <svg class="w-4 h-4 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    Distribution
                  </NuxtLink>


                  <NuxtLink v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87' || user.role === '4195f36a-5cdd-40c8-81aa-d4d8aec654fa'" to="/retailers" @click="isUserMenuOpen = false"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    :class="{ 'bg-gray-100 font-semibold text-gray-900': isActive('/retailers') }">
                    <svg class="w-4 h-4 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                    Retailers
                  </NuxtLink>

                  <NuxtLink v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/users" @click="isUserMenuOpen = false"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    :class="{ 'bg-gray-100 font-semibold text-gray-900': isActive('/users') }">
                    <svg class="w-4 h-4 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    Users
                  </NuxtLink>

                  <NuxtLink v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/admin" @click="isUserMenuOpen = false"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    :class="{ 'bg-gray-100 font-semibold text-gray-900': isActive('/admin') }">
                    <svg class="w-4 h-4 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Admin
                  </NuxtLink>

                  <NuxtLink v-if="user.role === 'f472c9f3-7c0d-44bd-a3c3-968be0bd2f87'" to="/data" @click="isUserMenuOpen = false"
                    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    :class="{ 'bg-gray-100 font-semibold text-gray-900': isActive('/data') }">
                    <svg class="w-4 h-4 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Ewarranty Data
                  </NuxtLink>

                  

                  <div class="my-1 border-t border-gray-100"></div>


                  <button @click="handleLogout"
                    class="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50">
                    <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                      </path>
                    </svg>
                    Logout
                  </button>



                </div>
              </div>
            </div>
          </div>
        </div>
      </UContainer>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
const user = useDirectusUser()
const { logout } = useDirectusAuth()
const router = useRouter()
const route = useRoute()

const isActive = (path: string) => {
  return route.path === path
}

const handleLogout = async () => {
  await logout()
  router.push('/login')
}

// Menu utilisateur : le logout est desormais derriere ce menu, qui accueillera
// aussi l'edition du profil quand la page existera.
const isUserMenuOpen = ref(false)
const userDropdownRef = ref(null)

const toggleUserMenu = () => {
  isUserMenuOpen.value = !isUserMenuOpen.value
}

// Les prenoms/noms sont saisis sans casse coherente dans Directus : on remet
// tout en minuscules puis on capitalise l'initiale, a l'affichage seulement.
const capitalize = (s?: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '')

// Un compte sans prenom/nom retombe sur l'email plutot que d'afficher "Welcome ".
const userFullName = computed(() =>
  [capitalize(user.value?.first_name), capitalize(user.value?.last_name)].filter(Boolean).join(' ')
  || user.value?.email
  || ''
)

// Menu "My Market" : relations du user connecte (collection distributors_accesses).
// Elles sont deja chargees par le middleware auth a chaque navigation protegee,
// on lit donc le store sans requete supplementaire.
const usersStore = useusersStore()

const marketAccesses = computed(() =>
  (usersStore.user?.dentsu_distributors_accesses ?? [])
    .filter((a: any) => a?.status === 'published' && a.distributor)
    .sort((a: any, b: any) =>
      (a.distributor.marketCode ?? '').localeCompare(b.distributor.marketCode ?? '')
    )
)

const isMarketMenuOpen = ref(false)
const marketDropdownRef = ref(null)

const toggleMarketMenu = () => {
  isMarketMenuOpen.value = !isMarketMenuOpen.value
}

// Dropdown state
const isDropdownOpen = ref(false)
const dropdownRef = ref(null)

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const openAlpina = () => {
  console.log('Opening Alpina...')
  window.open('https://ewarranty.alpinawatches.com/', '_blank')
  isDropdownOpen.value = false
}

const openFC = () => {
  console.log('Opening FC...')
  window.open('https://ewarranty.frederiqueconstant.com/', '_blank')
  isDropdownOpen.value = false
}

// Fermer le dropdown si on clique ailleurs
const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isDropdownOpen.value = false
  }
  if (marketDropdownRef.value && !marketDropdownRef.value.contains(event.target)) {
    isMarketMenuOpen.value = false
  }
  if (userDropdownRef.value && !userDropdownRef.value.contains(event.target)) {
    isUserMenuOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>